import _inherits from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _setPrototypeOf from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js";

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { return groups[name] = result[g[name]], groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

export var EMAIL_FORMAT_REGEX = /^\S+@\S+\.\S+$/;
export var ZIPCODE_FORMAT_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
export var PHONE_NUMBER_FORMAT_REGEX = /^[01]?[- .]?\(?[2-9]\d{2}\)?[- .]?\d{3}[- .]?\d{4}$/;
export var CREDIT_CARD_NUMBER_FORMAT_REGEX = /*#__PURE__*/_wrapRegExp(/(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13}))/, {
  visa: 1,
  mastercard: 2,
  discover: 3,
  amex: 4
});
export var CVC_FORMAT_REGEX = /^[0-9]{3,4}$/;
export var EXPIRATION_DATE_FORMAT_REGEX = /^[0-9]{2}\/[0-9]{2}$/;
export var USER_ID_FORMAT_REGEX = /^[0-9]{7,}$/i;
export var trim = function trim(e) {
  return null == e ? void 0 : e.trim();
};
export var validateNotEmpty = function validateNotEmpty(e) {
  return !!e.trim();
};
export var validateEmail = function validateEmail(e) {
  return new RegExp(EMAIL_FORMAT_REGEX).test(e);
};
export var validateZipCode = function validateZipCode(e) {
  return new RegExp(ZIPCODE_FORMAT_REGEX).test(e);
};
export var validatePhoneNumber = function validatePhoneNumber(e) {
  return new RegExp(PHONE_NUMBER_FORMAT_REGEX).test(e);
};
export var validateOptionalPhoneNumber = function validateOptionalPhoneNumber(e) {
  return !e || validatePhoneNumber(e);
};
export var validateCreditCardNumber = function validateCreditCardNumber(e) {
  return new RegExp(CREDIT_CARD_NUMBER_FORMAT_REGEX).test(e);
};
export var validateCvc = function validateCvc(e) {
  return new RegExp(CVC_FORMAT_REGEX).test(e);
};
export var validateExpirationDate = function validateExpirationDate(e) {
  var t = new Date(),
      r = t.getFullYear(),
      o = t.getMonth(),
      E = parseInt(e.slice(0, 2), 10);
  if (E > 12) return !1;
  var n = parseInt("20" + e.slice(3), 10);
  if (n < r || n > r + 3) return !1;
  if (n === r && E < o) return !1;
  return new RegExp(EXPIRATION_DATE_FORMAT_REGEX).test(e);
};
export var getNestedProp = function getNestedProp(e, t) {
  return 1 === t.length ? e[t[0]] : 0 === t.length ? void 0 : (e[t[0]] || (e[t[0]] = {}), getNestedProp(e[t[0]], t.slice(1)));
};
export var getErrorMessage = function getErrorMessage(e, t, r) {
  var o = getNestedProp(e, t);

  if (o) {
    if (o.message) return o.message;

    if ("validate" === o.type) {
      var _e = getNestedProp(r, t);

      return _e.required || _e.invalid;
    }
  }

  return "";
};